import { toastr } from "react-redux-toastr";

// Imports
import { doRequest } from "../../modules/request";
import { Sistema_ID } from "../../modules/constants";
import { forceInt } from "../../utils/forceInt";

export const REPEATED_APOSTA = "REPEATED_APOSTA";

export const repeatedAposta = (payload) => ({
  type: REPEATED_APOSTA,
  payload: payload,
});

export const repetirAposta = (objUser, aposta, errorCallback) => (dispatch, getState) => {
  const data = {
    Cliente_ID: objUser.Cliente_ID,
    Site_ID: forceInt(objUser.Site_ID),
    CID: objUser.CID,
    Sistema_ID: Sistema_ID,
    chrSerial: aposta.chrSerial,
    intNumeroPule: aposta.intNumeroPule,
    Session_ID: objUser.Session_ID,
  };

  const params = {
    url: "/RepetirAposta",
    method: "POST",
    data: data,
  };

  return doRequest(params)
    .then((response) => {
      if (response.intCodigoRetorno > 0) {
        if(errorCallback) errorCallback("Atenção", response.strErrorMessage);
        dispatch(
          repeatedAposta({
            arrAposta: [],
          })
        );
      } else {
        dispatch(repeatedAposta(response));
      }
      //callback();
    })
    .catch((error) => {
      if(errorCallback) errorCallback("Falha ao repetir aposta.", error.message);
      //callback();
    });
};



// WEBPACK FOOTER //
// ./src/reducers/repeticao/repeticaoActions.js